import { Button, Icon, Image } from '@chakra-ui/react'
import { toaster } from 'commons/design-system/components/Toaster'
import { TextColors } from 'commons/design-system/tokens'
import { getShareUrl } from 'commons/utils/shareUrlHelpers'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdCheck } from 'react-icons/md'

export const ShareButton = ({ isFromMoneyPot = false }: { isFromMoneyPot?: boolean }) => {
	const { t } = useTranslation()
	const [isCopied, setIsCopied] = useState(false)

	const copyUrlToClipboard = async (url: string) => {
		await navigator.clipboard.writeText(url)
		setIsCopied(true)

		toaster.create({
			title: t('success.share_link_copied'),
			type: 'success',
			duration: 2000,
			closable: true
		})

		setTimeout(() => {
			setIsCopied(false)
		}, 2000)
	}

	const handleShare = async () => {
		const shareUrl = getShareUrl()
		const shareData = { url: shareUrl, title: document.title }

		if (navigator.share && (!navigator.canShare || navigator.canShare(shareData))) {
			try {
				await navigator.share(shareData)
				return
			} catch (error) {
				if (error instanceof DOMException && error.name === 'AbortError') {
					return
				}
			}
		}

		try {
			await copyUrlToClipboard(shareUrl)
		} catch {
			toaster.create({
				title: 'Copy failed',
				description: 'Unable to copy URL to clipboard.',
				type: 'error',
				duration: 2000,
				closable: true
			})
		}
	}

	return (
		<Button
			bg='white'
			color={isCopied ? TextColors.STATUS_SUCCESS : TextColors.PRIMARY}
			onClick={handleShare}
			borderRadius='full'
		>
			{isCopied ? (
				<Icon as={MdCheck} boxSize='20px' color={TextColors.STATUS_SUCCESS} />
			) : (
				<Image
					src={
						isFromMoneyPot
							? `${process.env.REACT_APP_POTS_URL}collect/assets/img/payment/share.png`
							: `${process.env.REACT_APP_PAYMENT_FORM_URL}l/assets/img/payment/share.png`
					}
					alt='Share'
					w='20px'
					h='20px'
				/>
			)}
		</Button>
	)
}
